export enum ThresholdStatus {
  inStock = "In Stock",
  lowStock = "Low Stock",
  zeroStock = "Sold Out",
  discontinuedZero = "Sold Out",
}

export enum ThresholdCheckout {
  allow = "Allow",
  backorder = "Backorder",
  block = "Block",
  blockAndSubscribe = "Block Order and Suggest Stock Notification",
  optionalBackorder = "Optional Backorder",
}

export type ThresholdResult = {
  qtyString: string;
  qtyNum: number;
  dropdownContent: string;
  status: ThresholdStatus;
  checkout: ThresholdCheckout;
};

export const stockThreshold = (
  qty: number,
  category?: string,
  isDiscontinued = false,
): ThresholdResult => {
  let result: ThresholdResult = {
    qtyString: Math.round(qty).toLocaleString() + " ft",
    qtyNum: qty,
    dropdownContent: Math.round(qty).toLocaleString() + " ft",
    status: ThresholdStatus.inStock,
    checkout: ThresholdCheckout.allow,
  };

  switch (true) {
    case qty <= 10 && isDiscontinued:
      // console.log("[threshold.ts]: Condition 1 - Block");
      result = {
        ...result,
        qtyString: "",
        dropdownContent: "Sold Out",
        status: ThresholdStatus.zeroStock,
        checkout: ThresholdCheckout.block,
      };
      break;
    case qty <= 10:
      // console.log("[threshold.ts]: Condition 2 - Block");
      result = {
        ...result,
        qtyString: "",
        dropdownContent: "Sold Out",
        status: ThresholdStatus.zeroStock,
        // checkout: ThresholdCheckout.backorder,
        checkout: ThresholdCheckout.blockAndSubscribe,
      };
      break;
    case category === "Roma Elite" && qty < 20:
      // console.log("[threshold.ts]: Condition 3 - Block");
      result = {
        ...result,
        dropdownContent: result.dropdownContent + " (Low Stock)",
        status: ThresholdStatus.zeroStock,
        // checkout: ThresholdCheckout.backorder,
        checkout: ThresholdCheckout.allow,
      };
      break;
    case category === "Roma One" && qty < 50:
      // console.log("[threshold.ts]: Condition 4 - Block");
      result = {
        ...result,
        dropdownContent: result.dropdownContent + " (Low Stock)",
        status: ThresholdStatus.lowStock,
        // checkout: ThresholdCheckout.optionalBackorder,
        checkout: ThresholdCheckout.allow,
      };
      break;
    case category === "Simply Roma" && qty < 100:
      // console.log("[threshold.ts]: Condition 5 - Block");
      result = {
        ...result,
        dropdownContent: result.dropdownContent + " (Low Stock)",
        status: ThresholdStatus.lowStock,
        // checkout: ThresholdCheckout.optionalBackorder,
        checkout: ThresholdCheckout.allow,
      };
      break;
  }
  return result;
};
